export enum HTTPMethods {
  GET = 'GET',
  POST = 'POST',
  HEAD = 'HEAD',
  PUT = 'PUT',
  DELETE = 'DELETE'
}

export enum Entities {
  MobileSettings = 'mobile-settings',
  Contractors = 'contractors',
  Sensors = 'sensors',
  SensorState = 'sensor-state',
  SensorType = 'sensor-type',
  Gateway = 'gateway',
  GatewayState = 'gateway-state',
  Users = 'users',
  UserContractors = 'user-contractors',
  UserRoles = 'user-roles',
  UserMessageChannels = 'user-message-channels',
  UserSessions = 'user-sessions',
  Products = 'products',
  ProductsDrafts = 'products-drafts',
  ProductTips = 'product-tips',
  Manufacturers = 'manufacturers',
  ManufacturerAnnouncement = 'manufacturer-announcement',
  ManufacturerAnnouncementTypes = 'manufacturer-announcement-types',
  ManufacturerAnnouncementCategory = 'manufacturer-announcement-categories',
  ProductTypes = 'product-types',
  ProductTypesTips = 'product-types-tips',
  ProductPackageTypes = 'product-package-types',
  Projects = 'project',
  ProjectSections = 'project-sections',
  Events = 'events',
  EventTypes = 'event-types',
  BuildingTypes = 'building-types',
  ProjectTypes = 'project-types',
  Configuration = 'configuration',
  SensorConfiguration = 'sensor-configuration',
  SensorMissedReadings = 'sensor-missed-readings',
  SystemMessageTypes = 'system-message-types',
  SystemMessageTransportTypes = 'system-message-transport-types',
  SystemMessage = 'system-message',
  WagnerProbes = 'wagner-probes',
  ImportProductTemplateLink = 'import-proudcts-template-link',
  Release = 'release',
  Photo = 'photo',
  Label = 'label',
  SensorPastProjects = 'sensor-past-projects',
  Sections = 'sections',
  SensorReadout = 'sensor-readout',
  WagnerProbeReadings = 'wagner-probe-readings',
  Dashboard = 'dashboard',
  ProductRequest = 'product-requests',
  ProductRequestStatus = 'product-request-statuses',
  ReportTypes = 'report-types',
  Diagnostics = 'diagnostics',
  Reports = 'reports',
  UserNotifications = 'user-notifications',
  Tasks = 'tasks',
  ProductImport = 'product-import',
  AdvertisementPacket = 'advertisement-packet',
  WagnerDeviceFirmware = 'wagner-device-firmware',
  Documents = 'documents',
  Alerts = 'alerts',
  CombinedReportIncludedEvent = 'combined-report-included-events',
  CombinedReportComponent = 'combined-report-component',
  Attachments = 'attachments',
  DataLoggers = 'data-loggers',
  VerizonReports = 'verizon-reports',
  HeatIndexStandards = 'heat-index-standards',
  SensorBatteryStats = 'sensor-battery-stats',
  SensorBillingStats = 'sensor-billing-stats',
  SensorBillingEstimates = 'sensor-billing-estimates',
  SensorConfigurationAnalytics = 'sensor-configuration-analytics',
  SensorConfigurationAnalyticsSummary = 'sensor-configuration-analytics-summary',
  SensorConfigurationRequests = 'sensor-configuration-requests',
  BleConnectionLogs = 'ble-connection-logs',
  Prompts = 'prompts',
  SensorUploads = 'sensor-uploads',
  ContractorTransfers = 'contractor-transfers'
}

export enum LocalStorageKey {
  Auth = '__FLOORCLOUD_APP_AUTH__',
  NextSignInDate = '__FLOORCLOUD_APP_NEXT_SIGN_IN__'
}

export enum SensorStateList {
  All = 'all',
  New = 'new',
  Available = 'available',
  Assigned = 'assigned',
  InUse = 'in-use',
  Archived = 'archived',
  Lost = 'lost',
  Thingspace = 'thingspace',
  Diagnostics = 'diagnostics',
  VerizonReports = 'verizon-reports',
  UnusedSensor = 'unused-sensor'
}

export enum GatewayStateList {
  All = 'all',
  New = 'new',
  Available = 'available',
  Assigned = 'assigned',
  InUse = 'in-use',
  Lost = 'lost'
}

export enum SearchParamsKeys {
  Page = 'page',
  Sort = 'sort',
  RowsPerPage = 'rowsPerPage',
  State = 'state',
  Tab = 'tab',
  Search = 'search',
  Type = 'typeId',
  Contractor = 'contractorId',
  Manufacturer = 'manufacturerId',
  NoShelfLife = 'noShelfLife',
  NoTips = 'noTips',
  NoRanges = 'noRanges',
  Role = 'role',
  LastActive = 'lastActive',
  InUse = 'inUse',
  LocationType = 'locationType',
  ViewType = 'viewType',
  BatteryLevel = 'batteryLevel',
  LowBattery = 'lowBattery',
  CurrentProject = 'currentProject',
  Chart = 'chart',
  WeakSignal = 'weakSignal',
  SignalStrength = 'signalStrength',
  LastPingMoreThanHour = 'lastPingMoreThanHour',
  LastPingMoreThan = 'lastPingMoreThan',
  ExcludeStaging = 'excludeStaging',
  LastPing = 'lastPing',
  SyncPeriodLessThanHour = 'syncPeriodLessThanHour',
  SyncPeriod = 'synchronizationPeriod',
  AgeOfReadingsMoreThanHour = 'ageOfReadingsMoreThanHour',
  MapLegendType = 'mapLegendType',
  IsAvailableInSystem = 'isAvailableInSystem',
  IsAvailableInThingspace = 'isAvailableInThingspace',
  ActivationStatus = 'activationStatus',
  SubscriptionStatus = 'subscriptionStatus',
  HeatIndexStandardId = 'heatIndexStandardId',
  AssigneeId = 'assigneeId',
  CurrentSensorConfiguration = 'currentSensorConfiguration',
  EventTypes = 'eventTypes',
  HideServiceAccount = 'hideServiceAccount',
  WithPhotos = 'withPhotos',
  HideArchivedProjects = 'hideArchivedProjects',
  HideArchivedTasks = 'hideArchivedTasks',
  ConnectivityToProject = 'connectedToProject',
  IsBleEnabled = 'isBleEnabled',
  WagnerDeviceType = 'wagnerDeviceType',
  WagnerDeviceFirmwareTab = 'wagnerDeviceFirmwareTab',
  DatetimeFrom = 'datetimeFrom',
  DatetimeTo = 'datetimeTo',
  AttachmentStatus = 'attachmentStatus',
  SensorFirmwareVersion = 'sensorFirmwareVersion',
  AppVersion = 'appVersion',
  ProjectId = 'projectId',
  EventType = 'eventType',
  ProbeRawId = 'probeRawId',
  DeviceOS = 'deviceOS',
  ActivatedMoreThanMonths = 'activatedMoreThanMonths',
  NoPingMoreThanMonths = 'noPingMoreThanMonths',
  ConfigType = 'configType',
  Environment = 'environment',
  OrderNumber = 'orderNumber',
  OrderDateFrom = 'orderDateFrom',
  OrderDateTo = 'orderDateTo',
  OrderPart = 'orderPart'
}

export enum DialogNames {
  AssignSensorToContractor = 'assignSensorToContractor',
  DeleteProduct = 'deleteProduct',
  MassEditProductDrafts = 'massEditProductDrafts',
  DeleteBuildingType = 'deleteBuildingType',
  DeleteProjectType = 'deleteProjectType',
  AssignForemanToProject = 'assignForemanToProject',
  RemoveForemanFromProject = 'removeForemanFromProject',
  DeleteProductType = 'deleteProductType',
  DeleteUser = 'deleteUser',
  DeleteRelease = 'deleteRelease',
  DeleteVerizonReport = 'deleteVerizonReport',
  ArchiveUser = 'archiveUser',
  UnarchiveUser = 'unarchiveUser',
  DeleteManufacturer = 'deleteManufacturer',
  GetSensorHistoricalData = 'getSensorHistoricalData',
  DisconnectProbe = 'disconnectProbe',
  ProductRequestSummary = 'productRequestSummary',
  ProductRequestSummaryConfirmation = 'productRequestSummaryConfirmation',
  ChangeContractorType = 'changeContractorType',
  SensorGpxData = 'sensorGpxData',
  DeleteManufacturerAnnouncement = 'deleteManufacturerAnnouncement',
  CancelManufacturerAnnouncement = 'cancelManufacturerAnnouncement',
  ManageSensorBle = 'manageSensorBle',
  ArchiveSensor = 'archiveSensor',
  UnarchiveSensor = 'unarchiveSensor',
  ConfirmContractorDeactivation = 'confirmContractorDeactivation',
  DeleteManufacturerAnnouncementType = 'deleteManufacturerAnnouncementType',
  DeleteManufacturerAnnouncementCategory = 'deleteManufacturerAnnouncementCategory',
  DeleteWagnerDeviceFirmware = 'deleteWagnerDeviceFirmware',
  ConfigurationSettings = 'configurationSettings',
  EditReportIncludedEvents = 'editReportIncludedEvents',
  SensorAction = 'sensorAction',
  MarkLostSensor = 'markLostSensor',
  DisconnectSensor = 'disconnectSensor',
  ReassignInUseSensor = 'reassignInUseSensor',
  ReassignSensorToContractor = 'reassignSensorToContractor',
  DownloadMeasurements = 'downloadMeasurements',
  ArchiveUserContractor = 'archiveUserContractor',
  UnarchiveUserContractor = 'unarchiveUserContractor',
  DeleteUserContractor = 'deleteUserContractor',
  ConfirmOwnerRoleDowngrade = 'confirmOwnerRoleDowngrade',
  MakeSensorsReadyToUse = 'makeSensorsReadyToUse',
  AssignSensorsBulkPicker = 'assignSensorsBulkPicker',
  AssignSensorsBulkConfirmation = 'assignSensorsBulkConfirmation',
  DeletePrompt = 'deletePrompt',
  ConfirmMinimumAppVersion = 'confirmMinimumAppVersion',
  ActivateSensorInThingspace = 'activateSensorInThingspace',
  SensorConfigurationRequestPayload = 'sensorConfigurationRequestPayload',
  SensorsNotFound = 'sensorsNotFound',
  SensorsQualityControl = 'sensorsQualityControl',
  AssignSensorsQualityControl = 'assignSensorsQualityControl',
  RegenerateReport = 'regenerateReport',
  RetryContractorTransfer = 'retryContractorTransfer',
  CancelContractorTransfer = 'cancelContractorTransfer'
}

export enum UserRoles {
  Admin = 'admin',
  Foreman = 'foreman',
  PM = 'pm',
  ServiceAccount = 'service',
  Owner = 'owner',
  GeneralContractor = 'general_contractor'
}

export enum UserFilterRoles {
  Contractor = 'contractor', // PMs and Foreman
  Admin = 'admin'
}

export enum SensorModels {
  VERIZON_GAT = 'verizon_gat',
  TEKTELIK_TUNDRA = 'tektelik_tundra'
}

export enum XlsxAllowedTypes {
  Xlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  Xls = 'application/vnd.ms-excel'
}
export enum ImageAllowedTypes {
  PNG = 'image/png',
  JPEG = 'image/jpeg',
  JPG = 'image/jpg',
  HEIC = 'image/heic',
  HEIF = 'image/heif',
  HEIC_SEQUENCE = 'image/heic-sequence',
  HEIF_SEQUENCE = 'image/heif-sequence',
  ZIP = 'application/zip',
  APPLE_IMAGE = 'application/x-apple-diskimage',
  OCTET = 'application/octet-stream'
}

export enum LocationTypes {
  Cellural = 'cellural',
  GPS = 'gps'
}

export enum ViewTypes {
  List = 'list',
  Map = 'map'
}

export enum SensorFilters {
  Contractor = 'contractor',
  LowBattery = 'lowBattery',
  WeakSignal = 'weakSignal',
  LastPingMoreThanHour = 'lastPing',
  LastPingMoreThan = 'lastPingMoreThan',
  ExcludeStaging = 'excludeStaging',
  SyncPeriod = 'synchronizationPeriod',
  ReadingsAge = 'readingsAge',
  LocationType = 'locationType',
  AvailabilityInSystem = 'availabilityInSystem',
  AvailableInThingspace = 'availableInThingspace',
  ActivationStatus = 'activationStatus',
  CurrentSensorConfiguration = 'currentSensorConfiguration',
  BleStatus = 'bleStatus',
  FirmwareVersion = 'firmwareVersion',
  OrderNumber = 'orderNumber',
  OrderDate = 'orderDate'
}

export enum SensorButtons {
  DownloadLabels = 'downloadLabels',
  GetHistoricalData = 'getHistoricalData',
  ManageSensorBleState = 'manageSensorBleState',
  MakeReadyToUse = 'makeReadyToUse',
  Assign = 'assign',
  QualityControl = 'qualityControl'
}

export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc'
}

export enum MapLegendTypes {
  BatteryLevel = 'batteryLevel',
  SignalStrength = 'signalStrength'
}

export enum BatteryLevels {
  Low = 'low',
  Good = 'good'
}

export enum SignalStrengths {
  Good = 'good',
  Fair = 'fair',
  Weak = 'weak'
}

export enum ReadingType {
  Acceleration = 'acceleration',
  Battery = 'battery',
  Dewpoint = 'dewpoint',
  Humidity = 'humidity',
  Light = 'light',
  LocationCellular = 'locationCellular',
  LocationGps = 'locationGps',
  Orientation = 'orientation',
  Pressure = 'pressure',
  SignalStrength = 'signalStrength',
  Temperature = 'temperature',
  Diagnostic = 'diagnostic',
  Configuration = 'configuration',
  HeatIndex = 'heatIndex'
}

export enum ContractorFilters {
  Subscription = 'subscription',
  HeatIndexStandard = 'heatIndexStandard',
  Assignee = 'assignee'
}

export enum RapidRhFilters {
  ConnectivityToProject = 'connectivityToProject'
}

export enum FloorcloudSensorLocationType {
  GPS = 'gps',
  CELLULAR = 'cellid'
}

export enum WagnerDeviceFirmwareDeviceTypeEnum {
  DataGrabber = 'data_grabber',
  RangeExtender = 'range_extender'
}

export enum ProjectSectionStatusEnum {
  Active = 'active',
  Archived = 'archived'
}

export enum SensorTechnicalStatusEnum {
  Ok = 'ok',
  NotBad = 'not_bad',
  Unstable = 'unstable',
  Offline = 'offline',
  Failed = 'failed'
}

export enum ProductDraftSafetyTipTypeEnum {
  Default = 'default',
  Custom = 'custom'
}

export enum ProductDraftCommonTipTypeEnum {
  Default = 'default',
  Custom = 'custom'
}

export enum ProductDraftStatusEnum {
  Draft = 'draft',
  Published = 'published',
  Updated = 'updated',
  PendingReview = 'pending_review'
}

export enum ReportTypeNameEnum {
  Weekly = 'weekly',
  JobSiteConditions = 'job_site_conditions',
  SlabConditions = 'slab_conditions',
  ClimateRequirements = 'climate_requirements',
  ClimateConditions = 'climate_conditions',
  ContractorProjects = 'contractor_projects',
  CombinedReport = 'combined_report'
}

export enum AttachmentFilters {
  Status = 'status'
}

export enum SensorIcons {
  LinkOff = 'linkOff',
  Staging = 'staging',
  Archived = 'archived',
  Lost = 'lost'
}
